import { IntegrationSystem } from '@/shared/types';

import { SERVICE_CODES } from '@/lib/consts';

import { client } from '../../core/client';
import { DictionaryAuthorTypes, IncomingCorrespondenceRequest, IncomingCorrespondenceResponse } from '../../types';

import type { GeneralDictionaryType, DataResponse } from '../../types';

export const ars = {
  correspondenceSearch: (
    formData: IncomingCorrespondenceRequest,
    headers?: Headers,
  ): Promise<DataResponse<IncomingCorrespondenceResponse[]>> => {
    return client.post(`/user-requests/${SERVICE_CODES.SEARCH_INCOMING_CORRESPONDENCE}/search`, formData, headers);
  },
  dictionary: {
    authorTypes: (): Promise<DataResponse<DictionaryAuthorTypes[]>> => {
      return client.get(`/referenceBook/${IntegrationSystem.ARS}/getAuthorTypes`);
    },
    appealKinds: (): Promise<DataResponse<GeneralDictionaryType[]>> => {
      return client.get(`/referenceBook/${IntegrationSystem.ARS}/getAppealKinds`);
    },
  },
};
